import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { apiDeletePersonne } from "../../../api/ApiPersonnes";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;

  const submitData = async () => {
    await apiDeletePersonne(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminCollaborateurs.supprimer")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("admin.PageAdminCollaborateurs.confirmerSupprimer")}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
